import { ComposedChart, Bar, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";
import { fmtPeriod, fmtPeriodShort, fmtCompact, fmtCurrency } from "../../lib/format";

function CustomTooltip({ active, payload, label }) {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-brand-surface border border-brand-borderStrong shadow-sm px-4 py-3 text-sm">
      <p className="font-serif text-brand-ink mb-2">{fmtPeriod(label)}</p>
      {payload.map((p) => (
        <div key={p.dataKey} className="flex items-center justify-between gap-6">
          <span className="text-brand-muted flex items-center gap-1.5">
            <span className="h-2 w-2 rounded-full" style={{ background: p.color }} />
            {p.name}
          </span>
          <span className="font-mono text-brand-ink">{fmtCurrency(p.value)}</span>
        </div>
      ))}
    </div>
  );
}

export default function TrendChart({ data }) {
  return (
    <div className="bg-brand-surface border border-brand-border p-6" data-testid="trend-chart">
      <div className="flex items-baseline justify-between mb-6">
        <div>
          <p className="text-xs uppercase tracking-[0.15em] text-brand-tertiary">Performance Trend</p>
          <p className="font-serif text-xl text-brand-ink mt-1">Revenue &amp; Net Income over time</p>
        </div>
        <div className="hidden sm:flex items-center gap-4 text-xs text-brand-muted">
          <span className="flex items-center gap-1.5"><span className="h-2 w-3 bg-brand-gold" /> Revenue</span>
          <span className="flex items-center gap-1.5"><span className="h-2 w-3 bg-brand-primary" /> Net Income</span>
        </div>
      </div>
      <ResponsiveContainer width="100%" height={300}>
        <ComposedChart data={data} margin={{ top: 5, right: 5, left: 5, bottom: 0 }}>
          <CartesianGrid vertical={false} stroke="#E8E3DB" />
          <XAxis dataKey="period" tickFormatter={fmtPeriodShort} tick={{ fill: "#8A847A", fontSize: 11 }} axisLine={false} tickLine={false} />
          <YAxis tickFormatter={fmtCompact} tick={{ fill: "#8A847A", fontSize: 11 }} axisLine={false} tickLine={false} width={54} />
          <Tooltip content={<CustomTooltip />} cursor={{ fill: "rgba(30,58,47,0.04)" }} />
          <Bar dataKey="total_revenue" name="Revenue" fill="#C5A880" barSize={14} radius={[2, 2, 0, 0]} />
          <Line dataKey="net_income" name="Net Income" stroke="#1E3A2F" strokeWidth={2} dot={{ r: 2, fill: "#1E3A2F" }} activeDot={{ r: 4 }} />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
}
